document.querySelectorAll("[data-video-facade]").forEach((el) => {
  const button = el.querySelector("[data-video-facade-play]")
  if (!button) return

  button.addEventListener("click", () => {
    const iframe = document.createElement("iframe")
    iframe.src = el.dataset.videoFacade
    iframe.title = "Statspresso product demo"
    iframe.className = "h-full w-full"
    iframe.frameBorder = "0"
    iframe.allow = "autoplay; fullscreen; picture-in-picture; clipboard-write"
    iframe.allowFullscreen = true

    el.innerHTML = ""
    const wrapper = document.createElement("div")
    wrapper.className = "aspect-video w-full"
    wrapper.appendChild(iframe)
    el.appendChild(wrapper)
  })
})
